// PPN Breakdown helper — small strip that shows DPP · PPN 11% · Total (DPP+PPN),
// or a "Non PPN" chip when the project is exempt. Used in Contract/PO value inputs
// on ActiveProjectDialog and EditProjectDialog. User request 10-Feb-2026.
import { formatIDR, PPN_PCT } from "@/lib/constants";
import { Info } from "lucide-react";

export default function PPNBreakdown({ value, isExempt, testid = "ppn-breakdown" }) {
  const dpp = parseFloat(value) || 0;
  const ppn = isExempt ? 0 : Math.round(dpp * PPN_PCT * 100) / 100;
  const total = dpp + ppn;
  if (dpp <= 0) return null;
  return (
    <div className="mt-1 grid grid-cols-3 gap-1 border border-slate-200 bg-slate-50/60 p-1.5" data-testid={testid}>
      <div className="flex flex-col text-[10px] px-1.5">
        <span className="uppercase tracking-wider text-slate-500">DPP</span>
        <span className="tabular-nums font-semibold text-slate-800" data-testid={`${testid}-dpp`}>{formatIDR(dpp)}</span>
      </div>
      <div className={`flex flex-col text-[10px] px-1.5 border-l border-slate-200 ${isExempt ? "opacity-40" : ""}`}>
        <span className="uppercase tracking-wider text-sky-700 flex items-center gap-1">
          PPN 11%
          {isExempt && <Info size={9} className="text-slate-400" />}
        </span>
        <span className="tabular-nums font-semibold text-sky-800" data-testid={`${testid}-ppn`}>
          {isExempt ? <span className="italic text-slate-400 normal-case">exempt</span> : formatIDR(ppn)}
        </span>
      </div>
      <div className="flex flex-col text-[10px] px-1.5 border-l border-slate-200">
        <span className="uppercase tracking-wider text-emerald-700">Total</span>
        <span className="tabular-nums font-semibold text-emerald-800" data-testid={`${testid}-total`}>{formatIDR(total)}</span>
      </div>
    </div>
  );
}
